import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AuthContext } from "../../contexts/AuthContext";
import fetchAllStations from "../../services/fetchAllStations";
import vehicleStats from "../../utils/vehicleStats";
import ArrivedWidget from "./components/ArrivedWidget";
import BookedWidget from "./components/BookedWidget";
import CustomerWidget from "./components/CustomerWidget";
import ExitedWidget from "./components/ExitedWidget";
import MainChart from "./components/MainChart";
import SideChart from "./components/SideChart";
import StayedWidget from "./components/StayedWidget";
export default function Dashboard() {
  const { user } = useContext(AuthContext);
  const { selectedSite } = useSelector((state: any) => state.site);
  const [startDate, setStateDate] = useState(
    moment(new Date()).format("YYYYMMDD")
  );
  const [endDate, setEndDate] = useState(moment(new Date()).format("YYYYMMDD"));
  const [loading, setLoading] = useState(false);
  const [stations, setStations] = useState<any>([]);
  const [data, setData] = useState<any>([]);
  const site_id = selectedSite?._id || "6224dcf60c5c49d9fec9218f";

  const handleFetchStations = async () => {
    setLoading(true);
    const data = await fetchAllStations();
    setStations(data?.payload);
    const res = await vehicleStats(data?.payload);
    setData(res);
    setLoading(false);
  };

  useEffect(() => {
    handleFetchStations();
  }, []);

  return (
    <div className="m-4 bg-gray-100">
      <div className="grid grid-cols-12 gap-x-3 mb-4">
        <div className="col-span-12 sm:col-span-6 md:col-span-10">
          <div className=" grid grid-cols-12">
            <CustomerWidget />
            <ArrivedWidget site_id={site_id} />
            <ExitedWidget site_id={site_id} />
            <StayedWidget site_id={site_id} />
          </div>
          <div className="h-auto bg-white mb-4 border border-gray-300 rounded-lg m-2">
            <div className="border-b h-20 flex justify-center items-center">
              <div className="font-bold">Vehicle arrived</div>
            </div>
            <div className="bg-white  mx-2 mt-4 mb-6" style={{ height: 300 }}>
              <MainChart data={data} />
            </div>
          </div>
        </div>
        <div className="col-span-12 sm:col-span-6 md:col-span-2 mx-2 sm:mx-0">
          <BookedWidget startDate={startDate} endDate={endDate} />
          <div className="h-auto bg-white mb-4 border border-gray-300 rounded-lg">
            <div className="border-b h-20 flex justify-center items-center">
              <div className="font-bold">Vehicle analysis</div>
            </div>
            <div
              className="col-span-12 sm:col-span-6 md:col-span-3 bg-white mt-4 mb-6"
              style={{ height: 300 }}
            >
              <SideChart />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
